<button class="closeButton" mat-icon-button mat-dialog-close>
  <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon>
</button>
<sn-google-map zoom="13" [center]="organization" (mapInit)="onMapInit($event)">
  <div class="toggles">
    <button
      mat-icon-button
      matTooltip="Toggle Heatmap"
      (click)="toggleHeatmap()"
      [color]="heatmapActive ? 'accent' : null"
    >
      <sn-icon fontIcon="fa-chart-scatter" fontSet="fal"></sn-icon>
    </button>
    <button
      mat-icon-button
      matTooltip="Toggle Markers"
      (click)="toggleMarkers()"
      [color]="markersActive ? 'accent' : null"
    >
      <sn-icon fontIcon="fa-location-pin-slash" fontSet="fal"></sn-icon>
    </button>
  </div>
</sn-google-map>
